export default __webpack_public_path__ + "static/media/ic_alert_yellow.e72a8058.svg";